import { Component, OnInit, Input, Output, ViewChild } from '@angular/core';
import { EventEmitter } from 'events';
import { Subject, Observable } from 'rxjs';
import { MatSort, MatTableDataSource } from '@angular/material';
import { iHttpPaginatedResponse } from 'src/app/interfaces/iHttpPaginatedResponse';
import { FilterOption } from 'src/app/models/filter-option';
import { AccountService } from 'src/app/services/account.service';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-data-table',
  templateUrl: './data-table.component.html',
  styleUrls: ['./data-table.component.scss']
})
export class DataTableComponent implements OnInit {
  @Input('paginatedData') paginatedData:Subject<iHttpPaginatedResponse>;
  @Input('columns') columns;
  @Input('filters') filters: FilterOption[];
  @Output('sortChanged') sortChanged: Subject<string> = new Subject<string>();
  @Output('pageChanged') pageChanged: Subject<string> = new Subject<string>();
  @Output('perPageChanged') perPageChanged: Subject<string> = new Subject<string>();
  @Output('filterChanged') filterChanged: Subject<string> = new Subject<string>();
  @Input('route') route:string;
  public perPage:number=20;
  public currentPage:number=0;
  public lastPage:number=0;
  public totalItems:number=0;
  public pageSizeOptions:any=[20,50,100];

  private selectedFilters =[];

  @ViewChild(MatSort, {static: true}) sort: MatSort;
    public datasource;
    constructor(
      private _acc: AccountService,
      private _notify: NotificationService
    ) {
    }

  ngOnInit() {
    this.paginatedData.subscribe(iHttpPaginatedData=>{
      this.datasource= new MatTableDataSource(iHttpPaginatedData.data);
      this.perPage=iHttpPaginatedData.per_page;
      this.currentPage=iHttpPaginatedData.current_page-1;
      this.lastPage=iHttpPaginatedData.last_page-1;
      this.totalItems=iHttpPaginatedData.total;
      // console.log(this.columns);
    })
  }

  resendMemberVerification(memberId:number){
// build me
  }

  resendVerification(memberId:number){
    this._acc.resendVerificationEmail(memberId).subscribe(
      res=>{
        this._notify.showMessage(res.message, 'OK');
      }
    );
  }

  page(event) {
    this.pageChanged.next(event);
  }

  sortEvent(event){
    let sorts=event.active;
    if(event.direction=='desc'){
      sorts='-'+sorts;
    }
    this.sortChanged.next(sorts);
  }

  filterEvent(column,value) {
    let existingFilter=this.selectedFilters.filter(option=>{
      return option.column==column;
    })[0];

    if(!existingFilter){
      let filter = {column:column,value:value};
      this.selectedFilters.push(filter);
    }
    else{
      existingFilter.value = value;
    }

    let filterString='';

    this.selectedFilters.forEach((filter,i)=>{
      if(i==0){
        filterString=`filter[${filter.column}]=${filter.value}`;
      }
      else{
        filterString=filterString+`&filter[${filter.column}]=${filter.value}`;
      }
    })

    //console.log(filterString);
    this.filterChanged.next(filterString);
  }

  selectionChanged(event){
    //console.log(event);
  }
}
